import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import Button from '@ui/buttons/Button'
import { ModalBottom } from '@ui/components/Modal'
import { colors } from '@ui/colors'

interface Props {
  open: boolean
  isPrimary: boolean
  close: () => void
  isPending: boolean
  onRemove: () => void
}

export default function RemoveOrderModal({
  open,
  isPrimary,
  close,
  onRemove,
  isPending,
}: Props) {
  const { t } = useTranslation(['modals', 'ui'])
  const text = `modals:checkout.remove.${isPrimary ? 'primary' : 'order'}`
  return (
    <ModalBottom
      open={open}
      close={close}
      title={t(`${text}.title`)}
      desc={t(`${text}.desc`)}
      spacedText
      body={
        <View className="flex-row items-center gap-8 px-16">
          <Button
            variant="filled"
            label={t('ui:yesContinue')}
            loading={isPending}
            colors={[colors.red[600], colors.red[700]]}
            onPress={onRemove}
          />
          <Button
            variant="outlined"
            label={t('ui:cancel')}
            onPress={close}
            noninteractive={isPending}
          />
        </View>
      }
    />
  )
}
